import React from 'react';
import styled from 'styled-components';
import { useFavorites } from '../context/FavoritesContext';
import QuoteCard from './QuoteCard';

const FavoritesView = ({ onClose }) => {
  const { favorites } = useFavorites();

  return (
    <FavoritesContainer>
      <FavoritesHeader>
        <FavoritesTitle>Your Favorite Quotes</FavoritesTitle>
        <CloseButton onClick={onClose}>&times;</CloseButton>
      </FavoritesHeader>
      
      {favorites.length === 0 ? (
        <EmptyMessage>
          You haven't favorited any quotes yet. 
          Click the star icon on quotes you love to save them here.
        </EmptyMessage>
      ) : (
        <FavoritesList>
          {favorites.map(quote => (
            <FavoriteItem key={quote.id}>
              <QuoteCard quote={quote} />
            </FavoriteItem>
          ))}
        </FavoritesList>
      )}
    </FavoritesContainer>
  );
};

const FavoritesContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.95);
  z-index: 1000;
  overflow-y: auto;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const FavoritesHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  border-bottom: 1px solid #d4af37;
  padding-bottom: 1rem;
`;

const FavoritesTitle = styled.h2`
  font-family: var(--font-primary);
  font-size: 2rem;
  color: #d4af37;
  background: linear-gradient(to right, #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: var(--color-primary);
  font-size: 2.5rem;
  cursor: pointer;
  transition: color 0.3s ease;
  
  &:hover {
    color: #d4af37;
  }
`;

const FavoritesList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FavoriteItem = styled.div`
  height: 250px;
`;

const EmptyMessage = styled.p`
  font-family: var(--font-secondary);
  font-size: 1.2rem;
  color: var(--color-secondary);
  text-align: center;
  margin-top: 3rem;
  line-height: 1.6;
`;

export default FavoritesView;
